
<panel-item :class="`conditional_${fieldName}`">
  <row>
    <slot name="icon"></slot>
    <column>
      <!-- NOTE: the header slot is already wrapped in a <label> -->
      <label>
        <slot name="header"></slot>
        <span class="sr-only"><slot name="header"></slot> Conditional</span>
      </label>
    </column>
    <suffix>
      <div class="dropdown">
        <button
          v-if="canAddRule"
          class="dropdown-toggle btn-icon grey-to-blue add-rule"
          :id="`conditionButton_${fieldName}`"
          :disabled="disabled"
          @click="createConditionalDisplayRule"
          v-tooltip="'Add Rule'">
          <span class="sr-only">Add Rule Dropdown</span>
          <span class="icon-text plus"></span>
        </button>
      </div>
    </suffix>
  </row>

  <ul>
    <template v-if="Object.keys(conditionalRuleSets).length > 0">
      <template v-for="(ruleSet, index) in orderedConditionalRuleSets">
        <li>
          <conditional-display-rule
            :key="ruleSet.client_id"
            :class="{ 'condition-rule': true }"
            :conditional-rule-set="ruleSet"
            :totalRuleSets="Object.keys(conditionalRuleSets).length"
            :disabled="disabled"
            :validation-model="validationModel"
            :validation-field-name="validationFieldName"
            v-on:move-up="moveUp"
            v-on:move-down="moveDown"
            v-on:edit:conditional-rule-set="editConditionalRuleSet"
            v-on:remove:conditional-rule-set="removeConditionalRuleSet">
          </conditional-display-rule>
          <slot name="value" :uniqueId="index" :model="ruleSet" fieldName="conditional_value"></slot>
        </li>
      </template>
    </template>

    <li v-if="hasOtherwiseValue">
      <h6 v-if="Object.keys(conditionalRuleSets).length > 0">Otherwise</h6>
      <slot name="value" uniqueId="" :fieldName="fieldName" :model="parent"></slot>
    </li>
    <slot v-else-if="canAddRule" name="default"></slot>
  </ul>

  <conditional-display-modal v-if="editedRuleSet" :parent="parent" :ruleSet="editedRuleSet"
                             :state="modalStateFor(vueModalID.conditionalDisplay)"
                             :index="vueModalID.conditionalDisplay"
                             :key="editedRuleSet.client_id"
                             :conditional-rule-options="conditionalRuleOptions"
                             :configuring-conditional-step="configuringConditionalStep"
                             @toggle-modal="hideConditionalDisplayModal"
                             @finishedSettingCondition="finishedSettingCondition"
                             @cancel="$emit('cancel')"
  >
    <template #edit-rule-set="slotProps">
      <slot name="edit-rule-set" v-bind="slotProps" />
    </template>
  </conditional-display-modal>
</panel-item>
